<div class="course-library-list">
  <h4>{{ 'FILES_IN_THIS_STEP' | translate }}</h4>
  <mec-library-list
    [stepId]="stepId"
    [courseSlug]="courseSlug"
  ></mec-library-list>
</div>
